import { IBlock } from 'common/builder/blocks/blockInterfaces'
import { BlockType } from 'common/builder/constants/BlockType'

export const getBlockUrl = (block: IBlock) => {
  return block.type === BlockType.CARD ? block.defaultAction?.url : null
}
